import { edit } from "../actions";

const saveEdit = (todoId, text) => {
    return async (dispatch) => {
        const response = await fetch(`http://localhost:9000/todos/${todoId}`, {
            method: "PATCH",
            body: JSON.stringify({
                text,
            }),
            headers: {
                "Content-type": "application/json; charset=UTF-8",
            },
        });
        const todo = await response.json();

        console.log(todo);
        dispatch(edit(todo.id, todo.text));
    };
};

export default saveEdit;
